import styled from 'styled-components';

const GalleryStyle = styled.div`
	--distanceItem: var(--sp2x);
	--sizeImageLeftBar: 111.9%;
	--sizeImageWLeft: var(--sp18x);
	--radiusImageLeft: var(--sp1x);
	--radiusImageRight: var(--sp4x);
	--distanceRightLeft: var(--sp4x);
	--imageWidthR: 36.1vw;
	--sizeImageRight: 112.3%;

	.gallery-root {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: var(--distanceRightLeft);
	}

	.gallery-left-bar {
		display: flex;
		flex-direction: column;
		gap: var(--distanceItem);

		.wrap-image {
			border: 2px solid transparent;
			border-radius: var(--radiusImageLeft);
			width: fit-content;
			height: fit-content;
			overflow: hidden;
			transition: border var(--trTime) ease-out;
			cursor: pointer;

			.image-cont {
				--proportion: var(--sizeImageLeftBar);

				width: var(--sizeImageWLeft);
			}

			&.active {
				cursor: default;
				border: 2px solid var(--green1000);
			}

			&.animating {
				pointer-events: none;
				cursor: default;
			}
		}
	}

	.image-cont {
		display: flex !important;

		img {
			transition: opacity 0s !important;
		}
	}

	.gallery-content {
		display: flex;
		width: 100%;
		overflow: hidden;
		width: var(--imageWidthR) !important;

		.gallery-track {
			width: 100%;
			position: relative;
		}

		.gallery-slide {
			width: 100%;
		}

		.gallery-img-track {
			position: absolute;
			width: 100%;
			height: 100%;
			left: calc(100% + var(--sp1x));
			top: 0;
		}

		.image-cont {
			--proportion: var(--sizeImageRight);
			border-radius: var(--radiusImageRight);

			img {
				border-radius: var(--radiusImageRight);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceItem: var(--sp2x);
		--sizeImageWLeft: var(--sp10x);
		--radiusImageLeft: var(--sp1x);
		--sizeImageLeftBar: 111.9%;
		--radiusImageRight: var(--sp3x);
		--distanceRightLeft: var(--sp4x);
		--imageWidthR: 36.1vw;
		--sizeImageRight: 112.3%;
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceItem: var(--sp2x);
		--sizeImageWLeft: var(--sp10x);
		--radiusImageLeft: var(--sp1x);
		--sizeImageLeftBar: 111.9%;
		--radiusImageRight: var(--sp2-5x);
		--distanceRightLeft: var(--sp3x);
		--imageWidthR: 35.7vw;
		--sizeImageRight: 111.5%;
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceItem: var(--sp1-5x);
		--sizeImageWLeft: var(--sp7x);
		--radiusImageLeft: var(--sp1x);
		--sizeImageLeftBar: 116%;
		--radiusImageRight: var(--sp2x);
		--distanceRightLeft: var(--sp3x);
		--imageWidthR: 36vw;
		--sizeImageRight: 113%;
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceItem: var(--sp1-5x);
		--sizeImageWLeft: var(--sp8x);
		--radiusImageLeft: var(--sp1x);
		--sizeImageLeftBar: 116%;
		--radiusImageRight: var(--sp2x);
		--distanceRightLeft: var(--sp3x);
		--imageWidthR: 35.7vw;
		--sizeImageRight: 113%;
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceItem: var(--sp2x);
		--sizeImageWLeft: var(--sp8x);
		--radiusImageLeft: var(--sp0-5x);
		--sizeImageLeftBar: 116%;
		--radiusImageRight: var(--sp1-5x);
		--distanceRightLeft: var(--sp3x);
		--imageWidthR: 43.5vw;
		--sizeImageRight: 110.5%;

		.gallery-root {
			display: flex;
			flex-direction: column-reverse;
		}
		.gallery-left-bar {
			flex-direction: row;
		}
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--distanceItem: var(--sp2x);
		--sizeImageWLeft: var(--sp8x);
		--radiusImageLeft: var(--sp0-5x);
		--sizeImageLeftBar: 116%;
		--radiusImageRight: var(--sp1-5x);
		--distanceRightLeft: var(--sp2-5x);
		--imageWidthR: 100%;
		--sizeImageRight: 112.5%;
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceItem: var(--sp1-5x);
		--sizeImageWLeft: var(--sp6x);
		--radiusImageLeft: var(--sp0-5x);
		--sizeImageLeftBar: 116%;
		--radiusImageRight: var(--sp1-5x);
		--distanceRightLeft: var(--sp2x);
		--imageWidthR: 100%;
		--sizeImageRight: 112.5%;
	}
`;
export default GalleryStyle;
